































import Vue from 'vue'
import { RangeSliderPickerElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'RangeSliderPickerEl',

  data: () => ({
    rangeValue: [] as Array<number>,
    maxMinutes: 0,
    minMinutes: 0
  }),

  computed: {
    trackFillColor (): string {
      return this.templateItemData.barColor || 'var(--v-slideColor-base)'
    }
  },

  mounted () {
    this.initializeSliderData()
    this.minutesToLabels()
  },

  props: {
    templateItemData: {
      type: Object as () => RangeSliderPickerElInterface,
      required: true
    }
  },

  methods: {
    minutesToLabels () {
      const thumbs = document.getElementsByClassName('v-slider__thumb-label')
      const leftThumb = thumbs[0]
      const rightThumb = thumbs[1]

      leftThumb.getElementsByTagName('span')[0].innerHTML = this.toHoursAndMinutes(this.rangeValue[0])
      rightThumb.getElementsByTagName('span')[0].innerHTML = this.toHoursAndMinutes(this.rangeValue[1])
    },
    initializeSliderData () {
      this.minMinutes = this.toMinutes(this.templateItemData.minValue)
      this.maxMinutes = this.toMinutes(this.templateItemData.maxValue)
      const leftValue = typeof this.templateItemData.leftValue !== 'undefined' ? this.templateItemData.leftValue : '00:00'
      const rightValue = typeof this.templateItemData.rightValue !== 'undefined' ? this.templateItemData.rightValue : '00:00'
      this.rangeValue = [this.toMinutes(leftValue), this.toMinutes(rightValue)]
    },
    toHoursAndMinutes (totalMinutes: number): string {
      const minutes = totalMinutes % 60
      const hours = Math.floor(totalMinutes / 60)

      return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`
    },
    padTo2Digits (num: number) {
      return num.toString().padStart(2, '0')
    },
    toMinutes (hoursAndMinutes: string): number {
      const splitArray = hoursAndMinutes.split(':')
      const hours = parseInt(splitArray[0], 10)
      const minutes = parseInt(splitArray[1], 10)

      return hours * 60 + minutes
    }
  }
})
